import cx from 'classnames2';
import React from 'react';

import styles from './CharacterCounter.module.scss';

export interface ICharacterCounterProps {
  align?: 'left' | 'right';
  currentCount: number;
  dataTest?: string;
  maxCount: number;
}

export const CharacterCounter = (props: ICharacterCounterProps) => {
  const isOverLimit = props.currentCount > props.maxCount;

  const classnames = {
    [styles.default]: !isOverLimit,
    [styles.error]: isOverLimit,
    [styles.alignRight]: props.align === 'right',
    [styles.alignLeft]: props.align === 'left'
  };

  return (
    <span className={cx(classnames)} data-test={props.dataTest}>
      {props.currentCount}/{props.maxCount}
    </span>
  );
};

CharacterCounter.defaultProps = {
  align: 'right'
};
